import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "block bg-accent p-6" }
const _hoisted_3 = { class: "text-muted text-sm" }
const _hoisted_4 = { class: "text-3xl mt-2" }
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4"
}
const _hoisted_6 = { class: "text-muted text-sm" }
const _hoisted_7 = { class: "text-3xl mt-2" }


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

definePageMeta({ layout: false })

useHead({ title: 'admin' })

const { data: stats, status } = useAdminFetch<{
  talks: number
  talkGroups: number
  usesCategories: number
  usesItems: number
  hasLocation: boolean
}>('/api/admin/stats')

const showSkeleton = computed(() => status.value === 'pending' && !stats.value)

const cards = computed(() => [
  { label: 'Talks', value: stats.value?.talks ?? 0, to: '/admin/talks' },
  { label: 'Talk groups', value: stats.value?.talkGroups ?? 0, to: '/admin/talks' },
  { label: 'Uses categories', value: stats.value?.usesCategories ?? 0, to: '/admin/uses' },
  { label: 'Uses items', value: stats.value?.usesItems ?? 0, to: '/admin/uses' },
  { label: 'Location', value: stats.value?.hasLocation ? 'set' : 'not set', to: '/admin/location' },
])

return (_ctx: any,_cache: any) => {
  const _component_AdminSkeleton = _resolveComponent("AdminSkeleton")!
  const _component_NuxtLink = _resolveComponent("NuxtLink")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Dashboard" }, {
    default: _withCtx(() => [
      (_unref(showSkeleton))
        ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
              return _createElementVNode("li", { key: i }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_AdminSkeleton, { class: "bg-muted/20 w-20" })
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_AdminSkeleton, { class: "bg-muted/20 w-12" })
                  ])
                ])
              ])
            }), 64))
          ]))
        : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cards), (card) => {
              return (_openBlock(), _createElementBlock("li", {
                key: card.label
              }, [
                _createVNode(_component_NuxtLink, {
                  to: card.to,
                  class: "block bg-accent p-6 hover:bg-accent/80 transition-colors"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(card.label), 1),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(card.value), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ]))
    ]),
    _: 1
  }))
}
}

})